'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars


var DocumentContext = function (_Component) {
  _inherits(DocumentContext, _Component);

  function DocumentContext() {
    _classCallCheck(this, DocumentContext);

    return _possibleConstructorReturn(this, (DocumentContext.__proto__ || Object.getPrototypeOf(DocumentContext)).apply(this, arguments));
  }

  _createClass(DocumentContext, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        document: this.props.document,
        window: this.props.window
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return DocumentContext;
}(_react.Component);

DocumentContext.propTypes = {
  document: _propTypes2.default.object.isRequired,
  window: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.element.isRequired
};
DocumentContext.childContextTypes = {
  document: _propTypes2.default.object.isRequired,
  window: _propTypes2.default.object.isRequired
};
exports.default = DocumentContext;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-frame-component/lib/DocumentContext.js
// module id = 839
// module chunks = 0